import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the completions chart. */
export const CompletionPointSchema = z
  .object({
    bucket: z.string(),
    count: z.number().int().nonnegative(),
  })
  .strict();

export type CompletionPoint = z.infer<typeof CompletionPointSchema>;

/** One bucket of the test attempts chart, split by outcome. */
export const TestAttemptPointSchema = z
  .object({
    bucket: z.string(),
    passed: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    expired: z.number().int().nonnegative(),
  })
  .strict();

export type TestAttemptPoint = z.infer<typeof TestAttemptPointSchema>;

/** The Dashboard's Courses section (D12). */
export const CourseStatsSchema = z
  .object({
    window: StatsWindowSchema,
    completions: ComparableCountSchema,
    testAttempts: z.number().int().nonnegative(),
    passRate: z.number().min(0).max(1),
    discountsGranted: z.number().int().nonnegative(),
    discountsRedeemed: z.number().int().nonnegative(),
    completionsPerBucket: z.array(CompletionPointSchema),
    testAttemptsPerBucket: z.array(TestAttemptPointSchema),
  })
  .strict();

export type CourseStats = z.infer<typeof CourseStatsSchema>;
